<template>
    <div class="dropdownContainer">
        <div class="product-risk-detail" v-if="display === 'growth'">
            <div class="card">
                <div class="card-body pt-4">
                <div class="card-title pb-3">
                    <span class="info-icon">i</span>
                    <h5><a>Product Details and Risk</a></h5>
                    <span class="sprite icon-arrow-up" @click="toggleDetails"></span>
                </div>
                <p class="card-text">Your investment is spread across multiple, diversified loans that repay with interest every month over a 12 month lock-in. This interest income is re-invested every month to compound. You can choose the risk category of your portfolio of loans.Please visit FAQs section for more details and risks.</p>
                </div>
            </div>
        </div>
        <div class="product-risk-detail" v-else-if="display === 'income'">
            <div class="card">
                <div class="card-body pt-4">
                    <div class="card-title pb-3">
                        <span class="info-icon">i</span>
                        <h5><a>Product Details and Risk</a></h5>
                        <span class="sprite icon-arrow-up" @click="toggleDetails"></span>
                    </div>
                    <p class="card-text">Your investment is spread across multiple, diversified loans that repay with interest every month over a 12 month lock-in. This interest income is credited to your bank account monthly. You can choose the risk category of your portfolio of loans.  Please visit FAQs section for more details and risks.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductDetailsDropdown',
    props: {
        display: String
    },
    mounted () {
        document.addEventListener('click', this.toggleDetails)
    },
    beforeDestroy () {
        document.removeEventListener('click', this.toggleDetails)
    },
    methods: {
        toggleDetails () {
            this.$emit('closeDialog')
        }
    }
}
</script>

<style lang="scss" scoped>
.dropdownContainer {
    background-color: #fff;
    color: #323233;
    border-radius: 1rem;
    box-shadow: 0 0.25rem 0.25rem rgba(0, 0, 0, 0.25);
    border: 1px solid #E5E5E5;
    position: absolute;
    width: 110%;
    top: 50%;
    z-index: 1;
}
.product-risk-detail .card-title {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 0px !important;
}
.product-risk-detail .card-title h5 {
    font-weight: 400;
}
.product-risk-detail .card-title h5 a {
    font-size: 1.125rem;
    color: #071A90;
    text-decoration: underline;
}

.card-text {
    padding: 12px;
    font-size: 14px;
}

.product-risk-detail .info-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #020067;
    color: #fff;
    display: block;
    line-height: 24px;
    text-align: center;
    font-size: 0.8125rem;
    margin-right: 6px;
}
</style>
